<div class="material-panel">
  <div class="title">
    <h3>{{ 'ORDERS.MATERIAL.TITLE' | translate }}</h3>
  </div>

  <form [formGroup]="editMaterialForm">
    <div class="row col-12">
      <div class="row col-12 cell align_center-md">
        <eps-radio-group
          formControlName="type"
          [options]="typeOptions"
          disabledProperty="disabled"
          label="ORDERS.MATERIAL.TYPE"
          [radioButtonsDirection]="(isMobilePortraitScreen$ | async) ? 'column' : 'row'"
          autoSelect
        ></eps-radio-group>
      </div>

      <div class="col-12 hr"></div>
    </div>

    <eps-select
      [options]="palletIds"
      [freeze]="freezeFields"
      formControlName="palletId"
      *ngIf="isCombination() || isPallet()"
      label="ORDERS.MATERIAL.LABELS.TYPE_PALLET"
      class="col-12"
      autoSelect
    ></eps-select>

    <eps-select
      [options]="packingIds"
      [freeze]="freezeFields"
      formControlName="packingId"
      *ngIf="isCombination() || isPacking()"
      label="ORDERS.MATERIAL.LABELS.TYPE_PACKING"
      autoSelect
      class="col-12"
    ></eps-select>

    <eps-select
      [options]="packingStatusses"
      [freeze]="freezeFields"
      formControlName="packingStatus"
      *ngIf="isCombination() || isPacking() || isPallet()"
      label="ORDERS.MATERIAL.LABELS.STATUS_PACKING"
      class="col-12"
      autoSelect
    ></eps-select>

    <eps-select
      [options]="logisticsVarietyPackings"
      [freeze]="freezeFields"
      formControlName="logisticsVarietyPacking"
      *ngIf="isCombination() || isPacking() || isPallet()"
      label="ORDERS.MATERIAL.LABELS.LOGISTIC_VARIETY"
      class="col-12"
      autoSelect
    ></eps-select>

    <eps-select
      [options]="packingPerPalletList"
      [freeze]="freezeFields"
      formControlName="packingsPerPallet"
      *ngIf="isCombination()"
      label="ORDERS.MATERIAL.LABELS.PACKING_PER_PALLET"
      autoSelect
      class="col-12"
    ></eps-select>

    <eps-number-input
      label="ORDERS.MATERIAL.LABELS.NUMBER_OF_PALLETS"
      formControlName="numberOfPallets"
      class="col-12"
      *ngIf="isCombination() || isPallet()"
      [errors]="this.numberOfPalletsValidationErrorObject | async"
    ></eps-number-input>

    <eps-number-input
      label="ORDERS.MATERIAL.LABELS.QUANTITY"
      formControlName="packingQuantity"
      class="col-12"
      *ngIf="isPacking()"
      [errors]="this.packingQuantityValidationErrorObject | async"
    ></eps-number-input>

    <div class="col-12 hr"></div>

    <div class="col-12 buttons save-button">
      <eps-button
        [disabled]="saving || editMaterialForm.invalid"
        [busy]="saving"
        (buttonClick)="nextClickedFn()"
        submit
        [buttonIcon]="panelStatus.isNew ? 'plus' : null"
        [label]="panelStatus.isNew ? 'ORDERS.MATERIAL.BUTTONS.ADD_MATERIAL' : 'SHARED.BUTTONS.SAVE'"
      ></eps-button>
    </div>
  </form>
</div>
